import { IAppointmentBase } from '../../models/appointments';
import { IFeatureGroupBase } from '../../models/features';
import { IUserAssignmentBase, IUserBase } from '../../models/users';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListAppointmentProps {
  userName?: string;
  sort?: 'userName' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
  productId?: string;
}

interface IAppointmentListUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
}

interface IAppointmentListUser extends IUserBase {
  userAssignments: IAppointmentListUserAssignment[];
}

export interface IAppointmentListItem extends IAppointmentBase {
  user: IAppointmentListUser;
}

export type IAppointmentList = IListResponse<IAppointmentListItem>;

export const listAppointmentsService = async (
  filters?: IListAppointmentProps,
): Promise<IAppointmentList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          userName: filters.userName || undefined,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
          productId: filters.productId,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IAppointmentList>(
    '/appointments',
    {
      params,
    },
  );

  return data;
};
